import * as casbin from 'casbin.js';
import { compose, groupBy, mapValues } from 'lodash/fp';
import { constantCase } from 'constant-case';
import { createContext, useContext } from 'react';

export const EnforcerContext = createContext<string[][]>([]);

const authorizer = new casbin.Authorizer('manual');

export function useEnforcer() {
  const value = useContext(EnforcerContext);

  const permissions = compose(
    mapValues((ps) => ps.map((p) => constantCase(p[2]))),
    groupBy<[string, string, string]>((p) => constantCase(p[1])),
  )(value);

  authorizer.setPermission(permissions);

  return {
    // ...authorizer,
    can: (act: string, obj: string) => authorizer.permission?.check(act, obj) || false,
  };
}
